import styles from "./index.module.scss";
import { InboxOutlined } from "@ant-design/icons";
import { Spin, Upload } from "antd";
import ShareFileList from "../fileList";
import intl from "react-intl-universal";
const { Dragger } = Upload;

const FileUpload = ({
  suffix,
  multiple,
  typeTitle,
  fileList,
  upList,
  type,
  resourceType,
  secondType,
  onUpload,
  uploading = false,
}) => {
  const props = {
    accept: suffix,
    name: "file",
    multiple,
    action: "#",
    showUploadList: false,
  };

  const customRequest = (customRequestData) => {
    if (onUpload) {
      return onUpload(customRequestData);
    }
    const { file, onProgress, onSuccess } = customRequestData;
    onProgress({ percent: 100 }, file);
    onSuccess({ code: 200 }, file);
  };

  return (
    <div style={{ marginBottom: "50px" }}>
      <Spin
        spinning={uploading}
        tip={intl.get("File is uploading, please wait patiently")}
      >
        <Dragger
          {...props}
          customRequest={customRequest}
          disabled={!suffix || uploading}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            {intl.get("Click or drag file to this area to upload")}
            <span className={styles.limitBox}>
              （{suffix ? suffix : `please select 【${typeTitle}】 first`}）
            </span>
          </p>
          <p className="ant-upload-hint">
            {intl.get("Support for a single")} {multiple && <span>{intl.get("or bulk")}</span>} {intl.get("upload")}
          </p>
        </Dragger>
      </Spin>
      {fileList.length > 0 && (
        <ShareFileList
          files={fileList}
          upList={upList}
          type={type}
          resourceType={resourceType}
          secondType={secondType}
        />
      )}
    </div>
  );
};

export default FileUpload;
